import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  constructor(private translate: TranslateService, private router: Router) {
    translate.addLangs(['es', 'en']);

    if (localStorage.getItem('languaje') === 'es') {
      translate.use('es');
    } else if (localStorage.getItem('languaje') === 'en') {
      translate.use('en');
    } else {
      translate.setDefaultLang('es');
      localStorage.setItem('languaje', String('es'));
    }

  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Enviar vista de página a Google Analytics

        if (!event.urlAfterRedirects.includes("/callback/")) {

            gtag('event', 'page_view', {
              page_path: event.urlAfterRedirects
          });


        }

      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts